(function () {
  var body = document.body;
  if (!body) return;

  var baseCurrency = (body.getAttribute("data-base-currency") || "THB").trim();
  var targetCurrency = (
    body.getAttribute("data-target-currency") || baseCurrency
  ).trim();
  var targetLocale = (
    body.getAttribute("data-target-locale") || "en-US"
  ).trim();
  var marketPath = (body.getAttribute("data-market-path") || "/").trim() || "/";
  var convertRates = {
    GLOBAL: parseRate(body.getAttribute("data-convert-rate-global")),
    USD: parseRate(body.getAttribute("data-convert-rate-global")),
    THB: parseRate(body.getAttribute("data-convert-rate-thb")),
    SGD: parseRate(body.getAttribute("data-convert-rate-sgd")),
    JPY: parseRate(body.getAttribute("data-convert-rate-jpy")),
    MYR: parseRate(body.getAttribute("data-convert-rate-myr")),
    CNY: parseRate(body.getAttribute("data-convert-rate-cny")),
  };

  var ratesPromise = null;
  var cachedRate = null;

  ["AUD", "HKD", "TWD", "KRW"].forEach(function (code) {
    convertRates[code] = parseRate(
      body.getAttribute("data-convert-rate-" + code.toLowerCase()),
    );
  });
  if (
    ["AUD", "HKD", "TWD", "KRW"].indexOf(targetCurrency) !== -1 &&
    convertRates[targetCurrency] === null
  ) {
    // Do not label an unconverted THB amount with another currency.
    targetCurrency = baseCurrency;
    targetLocale = "th-TH";
  }

  function parseRate(value) {
    var normalized = String(value || "").trim();
    if (!normalized) return null;

    var rate = parseFloat(normalized);
    return isFinite(rate) && rate > 0 ? rate : null;
  }

  function usesConversion() {
    return targetCurrency !== baseCurrency;
  }

  function getCurrentMarketBaseAmount(cents) {
    var amount = Number(cents || 0) / 100;
    if (!isFinite(amount)) return 0;
    return amount;
  }

  function getAmount(cents, rate) {
    // Catalog prices already include the market's price adjustment.
    return getCurrentMarketBaseAmount(cents) * rate;
  }

  // Excel ROUND rounds halfway values away from zero.
  function roundLikeExcel(amount) {
    return (amount < 0 ? -1 : 1) * Math.round(Math.abs(amount));
  }

  function getRoundedDisplayAmount(amount, currencyCode) {
    var numericAmount = Number(amount || 0);
    if (!isFinite(numericAmount)) return 0;

    if (currencyCode === "KRW") {
      return roundLikeExcel((numericAmount + 100) / 1000) * 1000 - 100;
    }

    if (currencyCode === "AUD") {
      return roundLikeExcel((numericAmount + 0.05) / 5) * 5 - 0.05;
    }

    if (currencyCode === "HKD") {
      return roundLikeExcel((numericAmount + 1) / 10) * 10 - 1;
    }

    if (currencyCode === "TWD") {
      var nearestHundred = roundLikeExcel(numericAmount / 100) * 100;
      var endingNinety = nearestHundred - 10;
      var endingFifty = nearestHundred + 50;
      return Math.abs(numericAmount - endingNinety) <= Math.abs(numericAmount - endingFifty)
        ? endingNinety : endingFifty;
    }

    if (currencyCode === "USD") {
      return roundToUsdNinetyNine(numericAmount);
    }

    if (currencyCode === "THB") {
      return roundToEndingSet(numericAmount, [90], 100);
    }

    if (currencyCode === "SGD") {
      return roundToEndingSet(numericAmount, [5, 9], 10);
    }

    if (currencyCode === "MYR" || currencyCode === "CNY") {
      return roundToEndingSet(numericAmount, [9], 10);
    }

    if (currencyCode === "JPY") {
      return roundToNearestHundred(numericAmount);
    }

    return numericAmount;
  }

  function roundToNearestHundred(amount) {
    var sign = amount < 0 ? -1 : 1;
    return Math.round(Math.abs(amount) / 100) * 100 * sign;
  }

  function roundToUsdNinetyNine(amount) {
    var sign = amount < 0 ? -1 : 1;
    var absoluteAmount = Math.abs(amount);
    var roundedAmount = Math.max(0, Math.floor(absoluteAmount) - 0.01);

    return roundedAmount * sign;
  }

  function roundToEndingSet(amount, endings, step) {
    var sign = amount < 0 ? -1 : 1;
    var absoluteAmount = Math.abs(amount);
    var interval = step || 10;
    var normalizedEndings = Array.isArray(endings) ? endings : [];
    var base = Math.floor(absoluteAmount / interval) * interval;
    var candidates = [];

    for (var offset = -interval; offset <= interval * 2; offset += interval) {
      var candidateBase = base + offset;
      if (candidateBase < 0) continue;

      normalizedEndings.forEach(function (ending) {
        candidates.push(candidateBase + ending);
      });
    }

    var best = candidates[0] || 0;
    candidates.forEach(function (candidate) {
      var currentDistance = Math.abs(candidate - absoluteAmount);
      var bestDistance = Math.abs(best - absoluteAmount);
      if (
        currentDistance < bestDistance ||
        (currentDistance === bestDistance && candidate > best)
      ) {
        best = candidate;
      }
    });

    return best * sign;
  }

  function formatAmount(amount, currencyCode, locale) {
    var options = {
      style: "currency",
      currency: currencyCode,
    };
    if (currencyCode === "KRW") {
      options.minimumFractionDigits = 2;
      options.maximumFractionDigits = 2;
    }
    return new Intl.NumberFormat(locale, options).format(amount);
  }

  function resolveRateKey(currencyCode) {
    return currencyCode === "USD" ? "GLOBAL" : currencyCode;
  }

  function getRateForCurrency(currencyCode) {
    var normalizedCurrency = String(currencyCode || "").trim().toUpperCase();
    if (!normalizedCurrency || normalizedCurrency === baseCurrency) {
      return Promise.resolve(1);
    }

    if (normalizedCurrency === targetCurrency && typeof cachedRate === "number") {
      return Promise.resolve(cachedRate);
    }

    var rate = convertRates[resolveRateKey(normalizedCurrency)];
    if (typeof rate === "number") {
      if (normalizedCurrency === targetCurrency) {
        cachedRate = rate;
      }
      return Promise.resolve(rate);
    }

    if (normalizedCurrency === targetCurrency) {
      cachedRate = 1;
    }
    return Promise.resolve(1);
  }

  function formatConverted(cents, rate, currencyCode, locale) {
    var amount = getRoundedDisplayAmount(getAmount(cents, rate), currencyCode);
    return formatAmount(amount, currencyCode, locale);
  }

  function formatFallback(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      var format =
        window.Shopify.money_with_currency_format ||
        window.Shopify.money_format;
      if (format) return window.Shopify.formatMoney(cents, format);
    }

    return formatAmount(
      Number(cents || 0) / 100,
      usesConversion() ? targetCurrency : baseCurrency,
      targetLocale,
    );
  }

  function getDisplayAmountSync(cents) {
    if (usesConversion() && typeof cachedRate === "number") {
      return getRoundedDisplayAmount(
        getAmount(cents, cachedRate),
        targetCurrency,
      );
    }

    return Number(cents || 0) / 100;
  }

  function formatDisplayAmount(amount) {
    // These amounts already contain the markup and rounding for each item.
    var hasFormulaPricing = ["AUD", "HKD", "TWD", "KRW"].indexOf(targetCurrency) !== -1;
    var displayAmount = usesConversion() && !hasFormulaPricing
      ? getRoundedDisplayAmount(amount, targetCurrency)
      : Number(amount || 0);
    return formatAmount(
      displayAmount,
      usesConversion() ? targetCurrency : baseCurrency,
      targetLocale,
    );
  }

  function sumDisplayedAmountsSync(centsList) {
    return (centsList || []).reduce(function (sum, cents) {
      return sum + getDisplayAmountSync(cents);
    }, 0);
  }

  function sumDisplayedAmounts(centsList) {
    if (!usesConversion())
      return Promise.resolve(sumDisplayedAmountsSync(centsList));

    return getRate().then(function () {
      return sumDisplayedAmountsSync(centsList);
    });
  }

  function getRate() {
    if (!usesConversion()) return Promise.resolve(1);
    if (!ratesPromise) {
      ratesPromise = getRateForCurrency(targetCurrency);
    }
    return ratesPromise;
  }

  function applyElementValue(element, cents, rate) {
    if (!element) return;
    element.textContent = formatConverted(cents, rate, targetCurrency, targetLocale);
  }

  function enhancePrices(root) {
    var scope = root || document;
    var priceEls = scope.querySelectorAll("[data-money-cents]");
    if (!priceEls.length || !usesConversion()) return Promise.resolve();

    return getRate().then(function (rate) {
      priceEls.forEach(function (element) {
        applyElementValue(
          element,
          element.getAttribute("data-money-cents"),
          rate,
        );
      });
    });
  }

  window.MarmorisStorefrontCurrency = {
    baseCurrency: baseCurrency,
    targetCurrency: targetCurrency,
    targetLocale: targetLocale,
    usesConversion: usesConversion,
    usesPrettyPricing: false,
    getRate: getRate,
    getRateForCurrency: getRateForCurrency,
    getDisplayAmountSync: getDisplayAmountSync,
    formatDisplayAmount: formatDisplayAmount,
    sumDisplayedAmountsSync: sumDisplayedAmountsSync,
    sumDisplayedAmounts: sumDisplayedAmounts,
    formatMoneySync: function (cents) {
      if (usesConversion() && typeof cachedRate === "number") {
        return formatConverted(cents, cachedRate, targetCurrency, targetLocale);
      }
      return formatFallback(cents);
    },
    formatMoney: function (cents) {
      if (!usesConversion()) return Promise.resolve(formatFallback(cents));
      return getRate().then(function (rate) {
        return formatConverted(cents, rate, targetCurrency, targetLocale);
      });
    },
    formatBaseMoneyInCurrency: function (cents, currencyCode, locale) {
      var normalizedCurrency = String(currencyCode || "").trim().toUpperCase();
      var normalizedLocale = String(locale || targetLocale || "en-US").trim();

      if (!normalizedCurrency) return Promise.resolve(formatFallback(cents));

      return getRateForCurrency(normalizedCurrency).then(function (rate) {
        return formatConverted(cents, rate, normalizedCurrency, normalizedLocale);
      });
    },
    formatCurrentMarketBaseMoney: function (cents, locale) {
      var normalizedLocale = String(locale || "th-TH").trim();
      var currentMarketBaseAmount = getCurrentMarketBaseAmount(cents);
      return Promise.resolve(
        new Intl.NumberFormat(normalizedLocale, {
          style: "currency",
          currency: baseCurrency,
          currencyDisplay: "code",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(currentMarketBaseAmount),
      );
    },
    enhancePrices: enhancePrices,
  };

  document.addEventListener("DOMContentLoaded", function () {
    getRate().then(function () {
      enhancePrices(document);
    });
  });
})();
